var _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _g2, _g3, _g4, _path, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _rect, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectiveMindfulness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 262,
    height: 144,
    viewBox: "0 0 262 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11304_9720)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 102.637,
    cy: 76.2206,
    r: 12.9231,
    transform: "rotate(-4 102.637 76.2206)",
    fill: "#F9D5E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.554,
    cy: 82.2645,
    r: 12.9231,
    transform: "rotate(-4 116.554 82.2645)",
    fill: "#F9D5E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.8438,
    cy: 100.306,
    r: 12.9231,
    transform: "rotate(-4 97.8438 100.306)",
    fill: "#F9D5E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.921,
    cy: 86.2157,
    r: 12.9231,
    transform: "rotate(-4 90.921 86.2157)",
    fill: "#F9D5E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.346,
    cy: 98.1415,
    r: 12.9231,
    transform: "rotate(-4 113.346 98.1415)",
    fill: "#F9D5E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 88.0003,
    r: 8.61539,
    transform: "rotate(-4 104 88.0003)",
    fill: "#F3BB40"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 109.269,
    cy: 19.6255,
    r: 12.9231,
    transform: "rotate(-3 109.269 19.6255)",
    fill: "#F9D5E9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 123.079,
    cy: 25.9116,
    r: 12.9231,
    transform: "rotate(-3 123.079 25.9116)",
    fill: "#F9D5E9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.057,
    cy: 43.6236,
    r: 12.9231,
    transform: "rotate(-3 104.057 43.6236)",
    fill: "#F9D5E9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.3805,
    cy: 29.4146,
    r: 12.9231,
    transform: "rotate(-3 97.3805 29.4146)",
    fill: "#F9D5E9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.594,
    cy: 41.731,
    r: 12.9231,
    transform: "rotate(-3 119.594 41.731)",
    fill: "#F9D5E9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 110.428,
    cy: 31.4271,
    r: 8.61539,
    transform: "rotate(-3 110.428 31.4271)",
    fill: "#F3BB40"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 157.289,
    cy: 79.1456,
    r: 12.9231,
    transform: "rotate(4 157.289 79.1456)",
    fill: "#F9D5E9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 170.23,
    cy: 87.0675,
    r: 12.9231,
    transform: "rotate(4 170.23 87.0675)",
    fill: "#F9D5E9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 149.19,
    cy: 102.329,
    r: 12.9231,
    transform: "rotate(4 149.19 102.329)",
    fill: "#F9D5E9"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 144.296,
    cy: 87.4132,
    r: 12.9231,
    transform: "rotate(4 144.296 87.4132)",
    fill: "#F9D5E9"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.843,
    cy: 102.344,
    r: 12.9231,
    transform: "rotate(4 164.843 102.344)",
    fill: "#F9D5E9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 157,
    cy: 91.0001,
    r: 8.61539,
    transform: "rotate(4 157 91.0001)",
    fill: "#F3BB40"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11304_9720)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 203.063,
    cy: 48.9873,
    r: 11.0769,
    transform: "rotate(8 203.063 48.9873)",
    fill: "#F9D5E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213.654,
    cy: 56.5342,
    r: 11.0769,
    transform: "rotate(8 213.654 56.5342)",
    fill: "#F9D5E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.752,
    cy: 68.3262,
    r: 11.0769,
    transform: "rotate(8 194.752 68.3262)",
    fill: "#F9D5E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 191.459,
    cy: 55.2803,
    r: 11.0769,
    transform: "rotate(8 191.459 55.2803)",
    fill: "#F9D5E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 208.135,
    cy: 69.2754,
    r: 11.0769,
    transform: "rotate(8 208.135 69.2754)",
    fill: "#F9D5E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 202.107,
    cy: 59.1071,
    r: 7.38462,
    transform: "rotate(8 202.107 59.1071)",
    fill: "#F3BB40"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11304_9720)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 160.592,
    cy: 32.3579,
    r: 11.0769,
    transform: "rotate(9 160.592 32.3579)",
    fill: "#F9D5E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 171.05,
    cy: 40.0894,
    r: 11.0769,
    transform: "rotate(9 171.05 40.0894)",
    fill: "#F9D5E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.945,
    cy: 51.5493,
    r: 11.0769,
    transform: "rotate(9 151.945 51.5493)",
    fill: "#F9D5E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.88,
    cy: 38.4468,
    r: 11.0769,
    transform: "rotate(9 148.88 38.4468)",
    fill: "#F9D5E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 165.308,
    cy: 52.731,
    r: 11.0769,
    transform: "rotate(9 165.308 52.731)",
    fill: "#F9D5E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.459,
    cy: 42.4587,
    r: 7.38462,
    transform: "rotate(9 159.459 42.4587)",
    fill: "#F3BB40"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_11304_9720)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 63.6555,
    cy: 45.9258,
    r: 11.0769,
    transform: "rotate(-5 63.6555 45.9258)",
    fill: "#F9D5E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.673,
    cy: 50.8975,
    r: 11.0769,
    transform: "rotate(-5 75.673 50.8975)",
    fill: "#F9D5E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.9084,
    cy: 66.6387,
    r: 11.0769,
    transform: "rotate(-5 59.9084 66.6387)",
    fill: "#F9D5E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.7648,
    cy: 54.667,
    r: 11.0769,
    transform: "rotate(-5 53.7648 54.667)",
    fill: "#F9D5E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1613,
    cy: 64.5528,
    r: 11.0769,
    transform: "rotate(-5 73.1613 64.5528)",
    fill: "#F9D5E9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65.0001,
    cy: 56.001,
    r: 7.38462,
    transform: "rotate(-5 65.0001 56.001)",
    fill: "#F3BB40"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55 86C55 84.8954 55.8954 84 57 84H77.2654C78.2607 84 79.1046 84.7319 79.2453 85.7172L82.7547 110.283C82.8954 111.268 83.7393 112 84.7346 112H185.265C186.261 112 187.105 111.268 187.245 110.283L190.755 85.7172C190.895 84.7319 191.739 84 192.735 84H213C214.105 84 215 84.8954 215 86V112V138C215 139.105 214.105 140 213 140H183H87H57C55.8954 140 55 139.105 55 138V112V86Z",
    fill: "white"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 114.5,
    r: 1.5,
    fill: "white"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 41.5,
    r: 1.5,
    fill: "white"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 249.5,
    cy: 37.5,
    r: 1.5,
    fill: "white"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.5,
    cy: 4.5,
    r: 1.5,
    fill: "white"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 237.5,
    cy: 113.5,
    r: 1.5,
    fill: "white"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 170.5,
    cy: 1.5,
    r: 1.5,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 27 144)",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.5L36 20",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M207 15.5L227.5 9",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M243 66L259.5 69",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 84L21.5 78.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11304_9720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(74.1152 62.0215) rotate(-4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11304_9720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(181.68 32) rotate(8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11304_9720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(139.509 15) rotate(9)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_11304_9720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(39 34.1836) rotate(-5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveMindfulness);
export default __webpack_public_path__ + "static/media/collective-mindfulness.af97d930bac5c600a5f8f465273d5178.svg";
export { ForwardRef as ReactComponent };